export const m = {
    about: 'Trong khoảng',
    Qualification: 'trình độ chuyên môn',
    LegalDocument: 'tài liệu pháp lý',
    Partners: 'cộng sự',
    ContactUs: 'Liên hệ chúng tôi',
    Trade: 'BUÔN BÁN',
    IEO: 'IEO',
    OTC: 'OTC',
    News: 'TIN TỨC',
    Announcement: 'sự thông báo',
    IndustryNews: 'Công nghiệp Tin tức',
    Assets: 'Tài sản',
    Personalcenter: 'Trung tâm cá nhân',
    logout: 'rơi ra ngoài',
    login: 'đăng nhập',
    register: 'đã đăng ký',
    Exchange: 'đổi',
    LVOSubscribe: 'đăng ký',
    Notice: 'Để ý',
    Tradingpair: 'Cặp giao dịch',
    Latestprice: 'Giá cuối cùng',
    hChange: 'Thay đổi 24h',
    hHigh: 'Cao trong 24h',
    hLow: 'Thấp trong 24h',
    hVolume: 'Khối lượng 24h',
    Deal: 'Thỏa thuận',
    gBlockchain: 'Nền tảng giao dịch tài sản chuỗi khối toàn cầu',
    ReliableSystem: 'Hệ thống đáng tin cậy',
    RelGuaranteestem: 'Đảm bảo hoạt động an toàn, ổn định và hiệu quả của giao dịch',
    Elitewor: 'Đội ngũ tài năng ưu tú hàng đầu thế giới',
    Safetyfund: 'An toàn của quỹ',
    encryption: 'Mã hóa dữ liệu Https, xác minh danh tính',
    encryptarchitectureion: 'Kho lưu trữ Ví lạnh, kiến ​​trúc cấp độ tài chính, bảo vệ nhiều bảo mật',
    eexperienceon: 'Kinh nghiệm tốt nhất',
    eeMultilingualn: 'Rút tiền nhanh chóng, đa ngôn ngữ',
    Highperformance: 'Công cụ giao dịch hiệu suất cao, kinh nghiệm giao dịch nhanh chóng',
    Professionalservices: 'Những dịch vụ chuyên nghiệp',
    Professiinternational: 'Đội ngũ dịch vụ quốc tế chuyên nghiệp',
    problemsal: 'Phản hồi các vấn đề của người dùng một cách kịp thời',
    Anywhere: 'Buôn bán. Bất cứ nơi nào.',
    cryptocurrencye: "Tất cả sức mạnh của sàn giao dịch tiền điện tử của Cornucopia nằm trong lòng bàn tay của bạn. Tải xuống ứng dụng giao dịch tiền điện tử di động Cornucopia ngay hôm nay.",
    cryTradingcye: "bắt đầu giao dịch ngay bây giờ",
    Deposi: "tiền gửi",
    Help: "Cứu giúp",
    Registernow: "đăng ký ngay",
    Beginnerguide: "hướng dẫn cho người mới bắt đầu",
    FAQ: "Câu hỏi thường gặp",
    FADigitalQ: "giới thiệu Tài sản kỹ thuật số",
    PrivacyPolicy: "Chính sách bảo mật",
    Disclaimer: "từ chối trách nhiệm",
    UserAgreement: "Thỏa thuận người dùng",
    Mail: "thư",
    Address: "Địa chỉ",
    Unitedsta: "New York, hoa kỳ",
    UniDigitaltedsta: "Tài sản kỹ thuật số là các sản phẩm đầu tư sáng tạo có giá cả biến động cao và rủi ro đầu tư cao. Trước khi đầu tư, vui lòng nhận thức đầy đủ các tài sản kỹ thuật số, đánh giá hợp lý khả năng đầu tư của chúng và đưa ra quyết định đầu tư thận trọng.",
    Risktips: "mẹo rủi ro",
    COMMITTED: "CHÚNG TÔI CAM KẾT GIÚP CÁC DỰ ÁN BOLCKCHAIN TĂNG QUỸ TÌM ĐƯỢC NGƯỜI HỖ TRỢ, VÀ KIÊN TRÌ TƯ TƯỞNG VÀ QUAN TÂM ĐẾN Ý TƯỞNG TỐT.",
    CURRENCY: "TIỀN TỆ MỚI",
    CURInformationNCY: "Thông tin LVO -Token",
    CURInformatiFVG: "Thông tin FVG -Token",
    CURInformatcvv: "Thông tin CVV -Token",
    Circulation: "Vòng tuần hoàn",
    Liquidity: "Tính thanh khoản",
    Initialprice: "Giá ban đầu",
    Lockcycle: "Khóa chu kỳ",
    Deadline: "Hạn chót",
    DeaSubscrip: "Đếm ngược đăng ký",
    Subscribe: "Đăng ký",
    SessionTicket: "LVO - Đang tiến hành xác nhận quyền sở hữu vé phiên USDT",
    SOperatingt: "LVO- Hệ điều hành cho DApps",
    Price: "Giá bán",
    SessionSupply: "Cung phiên",
    Sessipaper: "Tải xuống sách trắng",
    Requirements: "Yêu cầu để tham gia bán mã thông báo này",
    Reqcompleteents: "Tất cả người dùng phải hoàn thành xác minh danh tính để đáp ứng các yêu cầu của dự án này",
    Pleaseents: "Vui lòng đăng nhập trước »",
    ProjectIntroduction: "giới thiệu dự án",
    Keyfeatures: "Các tính năng chính",
    Purposeof: "Mục đích của ",
    TOKENALLOCATION: "PHÉP TOKEN",
    TOKENSCHEDULE: "LỊCH PHÁT HÀNH TOKEN",
    MyAssets: "Tài sản của tôi",
    Withdrawhistory: "Hồ sơ gửi và rút tiền",
    SubscribeHistory: "Bản ghi đăng ký",
    Capitalflow: "Dòng vốn",
    Deposit: "Nạp điện",
    TotalAssets: "Tổng tài sản",
    Toconversionsets: "Lưu ý: Chuyển đổi tổng tài sản được ước tính dựa trên báo giá thị trường và chỉ mang tính chất tham khảo cho người dùng",
    SmallBalances: "Ẩn tiền tệ tài sản nhỏ",
    Currency: "Tiền tệ",
    Total: "toàn bộ",
    Available: "Có sẵn",
    Frozen: "Đông cứng",
    Description: "điều hành",
    Withdraw: "Rút tiền",
    WithdrawAddress: "Địa chỉ rút tiền",
    WithdrawAmount: "Số lần rút tiền",
    ServiceCharge: "Phí dịch vụ",
    Amountarrival: "Số lượng đến",
    fundpwd: "Mật khẩu quỹ",
    Tips: "Ghi chú",
    minimum: "Số tiền rút tối thiểu là ",
    musuallyum: "Việc rút tiền thường mất từ ​​2-24 giờ để hoàn tất và bạn sẽ được thông báo qua email khi đến nơi. Để đảm bảo an toàn cho tiền, chúng tôi sẽ tiến hành xem xét thủ công khi chính sách bảo mật tài khoản của bạn thay đổi, thay đổi mật khẩu hoặc rút tiền bằng địa chỉ mới. Quý khách vui lòng kiên nhẫn chờ nhân viên liên hệ qua điện thoại hoặc email.",
    muconfirmyum: "Đảm bảo xác nhận tính bảo mật của máy tính và trình duyệt của bạn để ngăn thông tin bị giả mạo hoặc bị rò rỉ.",
    forbiddenum: "Không được phép gửi và rút tiền giữa các tài khoản trên nền tảng Cornucopia và các hoạt động chuyển tiền có thể được thực hiện khi cần thiết.",
    DepositAddress: "Địa chỉ gửi tiền",
    Copy: "sao chép",
    blockchainCopy: "Tôi đã đứng đầu",
    confirmnCopy: "Đảm bảo xác nhận tính bảo mật của máy tính và trình duyệt của bạn để ngăn thông tin bị giả mạo hoặc bị rò rỉ.",
    forbidden: "Không được phép gửi và rút tiền giữa các tài khoản trên nền tảng Cornucopia và các hoạt động chuyển tiền có thể được thực hiện khi cần thiết.",
    Type: "Các loại",
    Startt: "Thời gian bắt đầu",
    EndTime: "Thời gian kết thúc",
    QUERY: "Hỏi thăm",
    Amount: "Định lượng",
    Balance: "thăng bằng",
    Time: "Thời gian",
    Status: "trạng thái",
    Commissions: "Phí dịch vụ toàn diện",
    Blockchainid: "ID chuỗi khối",
    Ins: "Đa dạng",
    TotalValue: "總價值",
    newcurrency: "Tiền mới đăng ký",
    Tokeninformation: "Thông tin thẻ",
    Day: "Chúa ơi",
    Dsubscriptionay: "Đăng ký của bạn",
    Pleaseonay: "Vui lòng nhập sổ tiết kiệm",
    availablebalance: "Số dư có sẵn",
    All: "tất cả",
    SUBMIT: "nộp",
    SUWelcomeBMIT: "Chào mừng trở lại, xin vui lòng nhập thông tin người dùng của bạn",
    Account: "Tài khoản",
    Password: "mật khẩu",
    ForgetPassword: "quên mật khẩu",
    notForaccount: "Vẫn chưa có tài khoản",
    Signnow: "Đăng ký ngay",
    Welcomejois: "Chào mừng tham gia cùng chúng tôi",
    Phone: "điện thoại",
    Email: "hộp thư",
    Nationality: "Quốc tịch",
    LoginPassword: "mật khẩu đăng nhập",
    ConfirmPassword: "xác nhận mật khẩu đăng nhập",
    VerificationCode: "Mã xác nhận",
    InvitationCode: "Mã mời",
    Ihavereae: "Tôi đã đọc",
    Useragreement: "Thỏa thuận người dùng",
    Existingaccount: "Bạn co săn san để tạo một tai khoản",
    Loginimmediately: "Đăng nhập ngay",
    BasicInformation: "Thông tin cơ bản",
    MyAccount: "tài khoản của tôi",
    Nickname: "tên nick",
    Change: "sửa đổi",
    UserID: "Tên người dùng",
    FundPassword: "Mật khẩu quỹ",
    FResetssword: "Đặt lại mật khẩu quỹ",
    Noteoriginal: "Lưu ý: Sau khi đặt lại, mật khẩu quỹ ban đầu sẽ bị hủy và mật khẩu mới sẽ được sử dụng cho các giao dịch.",
    DoubleAuthentication: "Xác thực hai yếu tố",
    Bind: "Trói buộc",
    Edit: "biên tập",
    Verification: "Đã xác minh",
    licensetype: "loại chứng chỉ",
    name: "Tên",
    licensenumber: "số ID",
    PaymentAccount: "Những tài khoản có thể nhận được",
    Add: "Thêm vào",
    Apaymentdd: "Bạn chưa thiết lập bất kỳ tài khoản nhận nào",
    Delete: "Xoá bỏ",
    LoginHistory: "Lịch sử đăng nhập",
    Loginmethod: "Phương thức đăng nhập",
    IP: "địa chỉ IP",
    Riskdisclosurebook: "Sách tiết lộ rủi ro",
    chinaz: "Việt nam",
    LatestNews: "Tin mới nhất",
    updatesnse: "Cập nhật thời gian thực, trực tiếp, giải mã thời gian đầu tiên",
    Curency: "BiZhong",
    Curplatformency: "Nền tảng thương mại toàn cầu hàng đầu",
    digitalency: "Giao dịch tiền tệ kỹ thuật số trong một môi trường an toàn, công bằng và minh bạch",
    coinsency: "Nơi tốt nhất để trao đổi tiền tệ kỹ thuật số",
    coIntegrationency: "金融與科技的融合",
    basictionency: "強大的基礎財務和交易基礎設施，採用多層和多集群系統架構，大幅提高系統的安全性、穩定性，AI 技術及微服務拆分設計應用，智能提升交易安全係數",
    bandency: "快速、簡潔的交易平台",
    basystemcy: "兆位記憶匹配系統，準確快速的交易指令執行，核心交易的低延遲",
    eliteemcy: "專業精英團隊",
    capabiqlities: "頂級區塊鏈、金融及 AI 領域踐行者打造專業團隊，具備強大的新業務、個性業務的快速開發能力，提供7*24 小時多語言客服支持",
    fairities: "安全、公平、透明的交易環境",
    regulatoryties: "持有多個國家的金融監管牌照，同時獲得美國財政部數字比交易許可證書",
}


// WEBPACK FOOTER //
// ./src/common/lang/yue.js